import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import axiosInstance from './services/apiinterseptor';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Handle token from URL (redirect from another portal) - run before React mounts
const urlParams = new URLSearchParams(window.location.search);
const hashParams = new URLSearchParams(window.location.hash?.replace(/^#/, '') || '');
const tokenFromUrl = urlParams.get('token') ?? urlParams.get('Token') ?? urlParams.get('accessToken') ?? hashParams.get('token') ?? hashParams.get('Token') ?? hashParams.get('accessToken');
if (tokenFromUrl) {
  localStorage.setItem('accessToken', tokenFromUrl);
  axiosInstance.defaults.headers.Authorization = `Bearer ${tokenFromUrl}`;
}

if (process.env.REACT_APP_ENV === "production") {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {}; 
  // keep console.error so real errors are still visible
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
